import { ServiceHandler } from '../../../utils';

const getNoteByIdHandler = ServiceHandler({
  url: `/api/quote/v1/note/:noteId`,
});
export const getNoteById = ({ noteId }: { noteId: string | number }) =>
  getNoteByIdHandler(noteId);

const createNoteHandler = ServiceHandler({
  url: `/api/quote/v1/note`,
  method: 'post',
});
export const createNote = (
  _params: Record<string, unknown> = {},
  data?: unknown
) => createNoteHandler({ data });

const updateNoteByIdHandler = ServiceHandler({
  url: `/api/quote/v1/note/:noteId`,
  method: 'put',
});
export const updateNoteById = (
  { noteId }: { noteId: string | number },
  data?: unknown
) => updateNoteByIdHandler(noteId, { data });

const createAccNoteHandler = ServiceHandler({
  url: `/api/account/v1/note`,
  method: 'post',
});
export const createAccNote = (
  _params: Record<string, unknown> = {},
  data?: unknown
) => createAccNoteHandler({ data });
